export default function valueToText(array, value) {
  const arrayItem = array.find(x => x.value === value);
  if (arrayItem && arrayItem.text) {
    return arrayItem.text;
  }
  return '';
}



// WEBPACK FOOTER //
// ./src/utils/valueToText.js